module.exports = __webpack_public_path__ + "img/quick_grip_banner.d5e083c9.jpg";